var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#53BE62",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.497 20.502C106.277 7.282 88.697 0 70 0 51.302 0 33.723 7.281 20.502 20.502 7.282 33.724 0 51.302 0 70c0 18.698 7.281 36.276 20.502 49.497C33.724 132.72 51.302 140 70 140c18.698 0 36.276-7.281 49.497-20.503C132.72 106.277 140 88.697 140 70c0-18.698-7.281-36.276-20.503-49.498zM70 131.797c-34.075 0-61.797-27.722-61.797-61.797C8.203 35.925 35.925 8.203 70 8.203c34.075 0 61.797 27.722 61.797 61.797 0 34.075-27.722 61.797-61.797 61.797z",
    transform: "translate(-651.000000, -664.000000) translate(330.000000, 382.000000) translate(321.000000, 282.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.804 47.193c-1.595-1.59-4.181-1.59-5.776 0L60.959 83.166 41.973 64.23c-1.595-1.591-4.182-1.591-5.777 0-1.595 1.59-1.595 4.17 0 5.76l21.875 21.817c.797.795 1.843 1.193 2.888 1.193s2.09-.398 2.888-1.193l38.957-38.853c1.595-1.591 1.595-4.17 0-5.761z",
    transform: "translate(-651.000000, -664.000000) translate(330.000000, 382.000000) translate(321.000000, 282.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.cb6c6a795755fe962a66bc8f28a90a0c.svg";
export { ForwardRef as ReactComponent };